import "@babel/polyfill";
import { copy_to_clipboard } from "./modules/clipboard";
import { category_list_accordion } from "./modules/list-accordion";

// Copy to Clipboard
copy_to_clipboard();

// Accordion for Category
category_list_accordion();
